// ─── Supabase Client Singleton ───────────────────────────────────────────────
// Single browser-side client used by all services.
// Uses the ANON key — safe to expose in the client bundle.
// Row-Level Security in Postgres ensures users can only access their own data.

import { createClient } from "@supabase/supabase-js";
import type { Database } from "../data/database.types";

export const supabase = createClient<Database>(
  import.meta.env.VITE_SUPABASE_URL as string,
  import.meta.env.VITE_SUPABASE_ANON_KEY as string
);
